export default {
  welcome: {
    your_language: 'Tu idioma',
    language_to_learn: 'Idioma que quieres aprender',
    start_learning: 'Comienza a aprender',
    how_does_this_work: 'Como funciona?',
    welcome_1: 'Bienvenido a JAALUU',
    welcome_2: 'Aquí puedes aprender idiomas',
    welcome_3: 'Leer textos o ver vídeos con subtítulos',
    welcome_4: 'Haga clic en una palabra para ver traducciones, ejemplos y definiciones',
    main_teaser: 'Mejora tus habilidades lingüísticas - de manera fácil y gratuita',
    hero_headline:
      'Deja de memorizar listas. Empieza a hablar con fluidez gracias a la inmersión con IA',
    hero_subheadline:
      'Jaaluu utiliza contenido real, conversaciones personalizadas con un chatbot y repetición espaciada para ayudarte a dominar un nuevo idioma en minutos al día.',
    hero_cta: 'Empieza gratis',
    select_language_and_start: 'Selecciona el idioma y empieza',
    how_to_title: 'Lee textos, libros, noticias o mira videos',
    how_to_text: 'Puedes elegir entre una variedad de textos, libros, noticias o videos',
    click_on_word_title: 'Traducción automática, ejemplos y definiciones',
    click_on_word_text:
      'Haz clic en cualquier palabra para obtener traducción automática, ejemplos de frases y definiciones. También puedes traducir oraciones completas automáticamente o vincular palabras con imágenes y crear redes de palabras.',
    listen_title: 'Escucha palabras y textos',
    listen_text:
      'Puedes escuchar cualquier palabra, oración o texto completo y practicar la pronunciación',
    conversations_title: 'Practica conversaciones',
    conversations_text:
      "Puedes practicar conversaciones hablando con un chatbot virtual. Debes resolver tareas como: 'Pedir comida en un restaurante' o 'Pedir direcciones'.",
    writing_title: 'Ortografía',
    writing_text_1: 'Practica la ortografía escribiendo textos',
    writing_text_2: 'Tus textos serán revisados por errores ortográficos, contenido y gramática.',
    texts_and_videos_title: 'Encuentra tu nivel',
    texts_and_videos_text:
      'Puedes elegir entre frases simples y textos para niños, noticias, artículos de Wikipedia o libros, lo que más te convenga',
    srs_title: 'Repite y entrena vocabulario',
    srs_text_1:
      'Puedes guardar cualquier palabra u oración completa como favoritos para repetirla más tarde',
    srs_text_2:
      'Entrena tu vocabulario con tarjetas didácticas y ejercicios simples, y sigue tu progreso',
    srs_text_3:
      'El sistema de repetición SRS te ayuda a aprender de manera más eficaz repitiendo palabras en el momento adecuado',
    own_text_title: 'Vocabulario especializado',
    own_text_text:
      'Puedes crear un texto sobre un tema específico para aprender vocabulario especializado. También puedes crear textos que contengan palabras que quieras aprender.',
    wordmap_title: 'Redes de palabras',
    wordmap_text_1: 'Puedes crear redes de palabras y vincular palabras con frases simples',
    wordmap_text_2:
      'Las tarjetas de palabras se pueden guardar como favoritos, lo que permite una repetición y entrenamiento fáciles',
    sayings_title: 'Modismos',
    sayings_text:
      'Aquí encontrarás frases y modismos comunes, categorizados. Puedes seguir tu progreso y continuar desarrollándote de manera estructurada.',
    details: 'Detalles',
    details_text_and_videos_title:
      'Descubre Jaaluu – ¡Tu clave para aprender idiomas rápido y eficazmente!',
    details_text_and_videos_text:
      'Jaaluu te ofrece una gran cantidad de textos y videos para mejorar tu nivel de idioma. La plataforma es ideal si ya puedes entender palabras y frases simples. Para principiantes, hay frases simples e idioms, textos para niños, diccionarios y videos para un fácil comienzo. Para estudiantes avanzados, hay noticias, artículos de Wikipedia, libros y videos interesantes para una comprensión más profunda, o conversaciones interactivas con chatbots. Además, puedes entrenar tu ortografía y recibir consejos para mejorar los errores ortográficos, el contenido y la gramática.',
    details_click_on_words_title: '¡Aprender vocabulario fácil: rápido, interactivo y sostenible!',
    details_click_on_words_text:
      'Aprender vocabulario puede ser tedioso porque buscar palabras y definiciones lleva mucho tiempo. Jaaluu resuelve este problema: simplemente haz clic en una palabra para obtener traducciones, ejemplos de frases, definiciones y explicaciones de inmediato. ¡Esto ahorra tiempo y te ayuda a aprender más rápido y eficazmente!',
    details_listen_title:
      'Escuchar y practicar: ¡Escucha palabras, frases y textos para mejorar tus habilidades lingüísticas!',
    details_listen_text:
      'Puedes escuchar todo: cualquier palabra, cualquier frase o incluso textos completos. ¡Solo haz clic y escucha! Esta función te ayuda a practicar la pronunciación correcta y mejorar la comprensión auditiva. También puedes escuchar conversaciones y desarrollar un sentido de comunicación natural. Perfecto para interiorizar vocabulario y fortalecer tus habilidades lingüísticas en situaciones cotidianas.',
    details_conversations_title:
      'Entrenamiento práctico de idiomas: ¡Conversaciones realistas para la vida diaria!',
    details_conversations_text:
      'Con Jaaluu, puedes practicar conversaciones realistas con un chatbot y prepararte para situaciones cotidianas típicas. Por ejemplo, puedes pedir comida en un restaurante y pagar la cuenta o pedir direcciones. O puedes chatear con tu nuevo colega en tu primer día de trabajo. Tus oraciones serán analizadas automáticamente para darte retroalimentación directa y mejorar tus habilidades lingüísticas. ¡De esta manera, entrenas de manera práctica y eficaz para conversaciones reales!',
    details_writing_title:
      'Práctica de escritura para la vida diaria: ¡Mejora tus habilidades con tareas realistas!',
    details_writing_text:
      'Puedes practicar la escritura dominando pequeñas tareas realistas, como escribir aplicaciones o cartas de queja. Luego, tu texto será analizado automáticamente y recibirás retroalimentación directa sobre ortografía, contenido y gramática. ¡De esta manera, mejoras tus habilidades de escritura y te preparas bien para la vida cotidiana!',
    details_srs_title:
      'Aprendizaje eficaz de vocabulario con SRS: ¡Repeticiones automáticas y análisis personalizado del progreso!',
    details_srs_text:
      'Con el sistema SRS (Sistema de Repetición Espaciada), puedes aprender y repetir vocabulario de manera eficaz. Este sistema te recuerda cuándo repetir palabras para retenerlas a largo plazo. SRS se basa en el método científico de que repetir a intervalos determinados fortalece la memoria. También recibirás estadísticas sobre el progreso de aprendizaje de cada palabra y tu tasa de éxito, para que puedas concentrarte en tus debilidades y siempre saber cómo estás progresando en el aprendizaje de vocabulario.',
    details_own_text_title:
      'Aprendizaje personalizado: ¡Crea textos a medida para ejercicios de vocabulario y temas específicos!',
    details_own_text_text:
      'Con Jaaluu, puedes crear fácilmente tus propios textos en áreas en las que quieras enfocarte. Describe el área o vocabulario que deseas aprender y recibirás un texto para leer y practicar. De esta manera, puedes concentrarte en temas o vocabulario específicos y ampliar tus conocimientos en el área que más te interese. ¡Este enfoque personalizado te ayuda a aprender de manera más eficaz y precisa! Además, puedes crear textos que contengan todo el vocabulario que quieras repasar. Esto te permite aprender y repasar vocabulario en contexto, lo que facilita su memorización.',
    details_wordmap_title:
      'Tarjetas de palabras: ¡Conecta tu conocimiento y recuerda las palabras con facilidad!',
    details_wordmap_text:
      'Puedes crear tarjetas de palabras que te ayuden a vincular palabras y recordarlas de manera más eficaz. Agrega palabras y oraciones de manera interactiva a tu tarjeta de palabras y expande gradualmente tu vocabulario. Esto crea y fortalece conexiones en tu cerebro y construye asociaciones de manera lúdica. ¡De esta manera, mejoras tu comprensión lingüística de manera sostenible!',
    details_paste_text_title:
      'Usa tus propios textos: ¡Pega tu contenido para aprender con enfoque!',
    details_paste_text_text:
      'Con Jaaluu, también puedes pegar tus propios textos para usarlos en la práctica. Esto te permite trabajar con tu propio material y entrenar tu vocabulario en contextos reales.',
    explore_more: 'Descubre más de Jaaluu',
    site_also_available: 'El sitio también está disponible en',
    which_language_title: '¿Qué idiomas puedo aprender?',
    which_language_text:
      'Aquí podrás aprender inglés, francés, italiano, portugués, alemán, ruso y polaco. ¡Simplemente selecciona el idioma que deseas aprender y listo!'
  },
  intro: {
    your_level: '¿Cuál es tu nivel de lengua?',
    beginner_explained: 'Puedes leer oraciones simples',
    intermediate_explained: 'Puedes leer textos y artículos simples',
    advanced_explained: 'Puedes leer textos más complejos',
    your_cefr_level: 'Tu nivel CEFR es',
    lets_start: '¿Con qué te gustaría empezar?',
    intermediate_options: {
      simple_texts: 'Leer textos',
      simple_articles: 'Leer artículos',
      sayings: 'Aprender refranes',
      simple_phrases: 'Leer frases típicas',
      klexikon: 'Leer Klexikon (Enciclopedia para niños)'
    },
    advanced_options: {
      news: 'Leer noticias',
      wikipedia: 'Leer artículos',
      books: 'Leer libros',
      conversations: 'Practicar conversaciones',
      writing: 'Practicar escritura'
    }
  },
  languages: {
    de: 'Alemán',
    en: 'Inglés',
    es: 'Español',
    fr: 'Francés',
    it: 'Italiano',
    pt: 'Portugués',
    ru: 'Ruso',
    zh: 'Chino',
    pl: 'Polaco'
  },
  general: {
    close: 'Cerrar',
    home: 'Inicio',
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    search: 'Buscar',
    what_to_read: '¿Qué te gustaría leer?',
    search_imperative: 'Busca',
    translate: 'Traducir',
    what_you_want_to_translate: '¿Qué quieres traducir de {from} a {to}?',
    word_not_found: 'La palabra "{word}" no parece existir.',
    similar_words_found: 'Encontré las palabras más similares:',
    settings: 'Ajustes',
    vocabulary: 'Vocabulario',
    most_important_words: '{n} palabras más importantes',
    learn_most_important_words: 'Aprende las 500 palabras más importantes',
    continue_with_word: 'Continuar con la palabra {n}',
    jokes: 'Chistes',
    n_jokes: '{n} chistes',
    learn_jokes: 'Aprende 200 chistes',
    continue_with_joke: 'Continuar con el chiste {n}',
    shorts: 'Textos cortos',
    articles: 'Artículos',
    feeds: 'Noticias',
    videos: 'Videos',
    read: 'Leer',
    view: 'Ver',
    listen: 'Escuchar',
    save: 'Guardar',
    more: 'mas',
    back: 'Atrás',
    next: 'Siguiente',
    continue_with_sentence: 'Continuar con la frase {sentenceIdx}',
    easy: 'Fácil',
    medium: 'Medio',
    hard: 'Difícil',
    all: 'Todos',
    level: 'Nivel',
    font_size: 'Tamaño de fuente',
    language: 'Idioma',
    send: 'Enviar',
    image: 'Imagen',
    wordmap: 'Mapa de palabras',
    open: 'Abrir',
    add: 'Añadir',
    question: 'Pregunta',
    start: 'Comenzar',
    continue: 'Continuar',
    words: 'Palabra | Palabras',
    points: 'Punto | Puntos',
    repeat: 'Repetir',
    test: 'Probar',
    nothing_found: 'Nada encontrado',
    skip: 'Saltar',
    congratulations: 'Felicitaciones',
    well_done: '¡Bien hecho!',
    try_again: 'Inténtalo de nuevo',
    finish: 'Terminar',
    total: 'Total',
    synapsis_score: 'Synapsis Score',
    synapsis_milestone: '¡Hito de puntuación de sinapsis! Nuevo puntaje: {score}',
    fun_facts: 'Curiosidades sobre {country}',
    fun_facts_missing_points: 'Puntos para la próxima curiosidad sobre {country}',
    fun_facts_previous: 'Curiosidades anteriores ({count})',
    fun_fact_unlocked: 'Ahora puedes ver una nueva curiosidad sobre {country}',
    finished_units: 'Unidad | Unidades',
    finished_course_chapters: 'Capítulo del curso | Capítulos del curso',
    grammar_chapters: 'Capítulo de gramática | Capítulos de gramática',
    completed: 'Completado',
    turn: 'Girar'
  },
  app_bar: {
    search_in_foreign_language: 'Buscar en idioma extranjero',
    menu: 'Menú'
  },
  category: {
    chapter: 'Capítulo',
    learn_most_common_pre: 'Aprende los más comunes',
    learn_most_common_post: 'de muchas categorías diferentes',
    or_choose_a_category: 'Elige una categoría:',
    chapter_end: '¡Llegaste al final de este capítulo!',
    phrases: 'Frases',
    sayings: 'Dichos',
    simple_texts: 'Textos',
    conversations: 'Conversaciones',
    write: 'Escritura',
    course: 'Curso'
  },
  favorites: {
    favorites: 'Favoritos',
    word: 'Palabra',
    sentence: 'Oracion',
    sentences: 'Oraciones',
    texts: 'Textos',
    wordmaps: 'Mapas de palabras',
    saved: 'Guardado',
    title: 'Título',
    type: 'Tipo',
    no_favorites_found: 'No se encontraron favoritos',
    filtered_by: 'filtrado por',
    train: 'Entrenar',
    train_words: 'Entrenar {wordCount} palabras',
    notify_me_srs: 'Notificarme para repetir vocabulario con SRS',
    action_sounds: 'Sonidos de acción',
    srs_level: 'Nivel SRS',
    success_rate: 'Tasa de éxito',
    word_type: 'Tipo de palabra',
    translation: 'Traducción',
    context: 'Contexto',
    last_seen: 'Última vez visto',
    next_review: 'Próxima revisión',
    short_story: 'Cuento corto',
    success_level_up: 'La palabra ha subido al nivel {level}',
    success_level_up_celebrate: '¡La palabra {word} pasó al siguiente nivel!',
    what_is_srs: '¿Qué es el SRS?',
    srs_short:
      'El SRS es un sistema de repetición espaciada. Te ayuda a recordar las palabras mejor repitiéndolas en el momento adecuado.',
    srs_long:
      'El sistema se basa en el principio de que, cuanto más repites una palabra, mejor la recuerdas. Los intervalos entre repeticiones son determinados por el sistema. Si recuerdas bien una palabra, los intervalos se hacen más largos. Si tienes dificultades, los intervalos se hacen más cortos. De esta manera, puedes aprender palabras de forma más eficiente.',
    srs_intervals: 'Los {nIntervals} intervalos son: {intervals} días.',
    when_does_a_word_move: '¿Cuándo una palabra pasa al siguiente nivel?',
    srs_next_level_example_1:
      'Si agregas una palabra a los favoritos, estará en el nivel 1. Una palabra en el nivel 1 pasará al siguiente nivel si ha pasado 1 día desde que agregaste la palabra, tu tasa de éxito es superior al 50% y acabas de recordar la palabra correctamente.',
    srs_next_level_example_2:
      'Una palabra en el nivel {level} pasará al siguiente nivel después de que el último cambio al nivel {levelM1} haya sido al menos {days} días atrás, tu tasa de éxito es superior al 50% y acabas de recordar la palabra correctamente.',
    favorite_group: 'Gruppe',
    group_already_exists: 'Ya existe una carpeta con ese nombre',
    cannot_delete_default: 'La carpeta `Default` no se puede eliminar',
    group_still_has_words:
      'La carpeta todavía contiene favoritos. Por favor elimina primero todos los favoritos.',
    group_deleted: 'Carpeta eliminada'
  },
  player: {
    maximize: 'Maximizar',
    minimize: 'Minimizar'
  },
  video: {
    error:
      'Hubo un error al cargar los subtítulos. Lamentablemente, no todos los subtítulos son de libre acceso. Por favor prueba con otro vídeo.'
  },
  feeds: {
    disclaimer:
      'Esta es un resumen generado automáticamente por Chatgpt. El artículo original está disponible',
    here: 'aquí',
    generating_article: 'Generando artículo...',
    error:
      'Hubo un error al cargar el artículo. Lamentablemente, no todos los artículos son de libre acceso. Pruebe con otro artículo o copie el texto manualmente.',
    open_org: '1. Abrir artículo original y copiar texto',
    open_own: '2. Insertar texto aquí'
  },
  books: {
    read_now: 'Leer ahora',
    continue_on_page: 'Continuar en la página'
  },
  tooltip: {
    examples: 'Ejemplos',
    emotional_examples: 'Ejemplos emocionales',
    definition: 'Definición',
    base_word: 'Forma base',
    synonyms: 'Sinónimas',
    antonyms: 'Antónimos',
    article: 'Artículo',
    conjugations: 'Conjugación',
    grammer: 'Gramática',
    etymology: 'Etimología',
    all_meanings: 'Todos los significados',
    context: 'Contexto'
  },
  custom_text: {
    enter_your_own_text: 'Introduce tu propio texto',
    read_text: 'Leer texto',
    enter_new_text: 'Introduce un nuevo texto',
    own_text: 'Copia tu propio texto y pégalo aquí',
    special_vocabulary: 'Vocabulario especial'
  },
  special_vocabulary: {
    special_vocabulary: 'Vocabulario especial',
    explanation:
      'Aquí puedes crear un nuevo texto sobre un tema que te gustaría estudiar. Se generará un texto que podrás usar para estudiar.',
    describe: 'Ingresa un texto en inglés sobre un tema o vocabulario especial que deseas aprender',
    language_level: 'Nivel de idioma',
    generate_text: 'Generar texto'
  },
  custom_vocabulary: {
    custom_vocabulary: 'Vocabulario personalizado',
    add_new_category: 'Añadir nueva categoría',
    title: 'Título',
    description: '¿Qué vocabulario quieres aprender?',
    description_placeholder: 'Describe el vocabulario que deseas aprender',
    description_example: "Ejemplo: 'Números del 1 al 20'",
    number_of_words: 'Número de vocablos',
    generate: 'Generar',
    no_lists_found: 'Todavía no hay listas de vocabulario personalizado',
    list_not_found: 'No se encontró esta lista de vocabulario',
    error_generating: 'Se produjo un error al generar el vocabulario. Inténtalo de nuevo.',
    home_teaser: 'Crea tus propias listas de vocabulario sobre cualquier tema que quieras aprender',
    n_lists: 'lista personalizada | listas personalizadas'
  },
  live_conversations: {
    start_conversation: 'Iniciar conversación',
    end_conversation: 'Terminar conversación',
    connecting: 'Conectando…',
    connected: 'Conversación en curso…',
    microphone_error:
      'No se pudo iniciar la conversación. Comprueba el acceso al micrófono e inténtalo de nuevo.',
    not_found: 'No se encontró esta conversación',
    reviewing: 'Revisando tu conversación…',
    transcript_title: 'Tu conversación',
    no_turns: 'No se registró ninguna conversación.',
    no_mistakes: '¡No se encontraron errores, muy bien!',
    review_unavailable: 'No se pudo cargar la revisión. Inténtalo de nuevo más tarde.'
  },
  intro_message: {
    save_word_as_fav: 'Haz clic en la estrella para guardar la palabra como favorita',
    save_video_as_fav: 'Haz clic en la estrella para guardar el video como favorito',
    save_article_as_fav: 'Haz clic en la estrella para guardar el artículo como favorito',
    save_book_as_fav: 'Haz clic en la estrella para guardar el libro como favorito',
    save_wordmap_as_fav: 'Haz clic en la estrella para guardar el mapa de palabras como favorito',
    play_word: 'Haz clic en el botón de reproducción para escuchar la pronunciación de la palabra',
    play_article: 'Haz clic en el botón de reproducción para escuchar el artículo',
    play_book: 'Haz clic en el botón de reproducción para escuchar el libro',
    select_main_category: 'Selecciona una categoría principal',
    select_sub_category: 'Selecciona una subcategoría',
    click_on_read: 'Haz clic en `LEER` para leer el texto completo',
    click_on_view: 'Haz clic en `VER` para ver un video',
    wordmap_click_on_word: 'Haz clic en la palabra para ver las palabras más utilizadas',
    wordmap_click_on_line: 'Haz clic en una línea entre dos palabras para ver una oración',
    conversations_select_scene: 'Selecciona un ejercicio',
    conversations_warn:
      'Parece que hay un error en tu oración. Haz clic en el triángulo para más explicaciones.',
    conversations_task: 'Formula una oración basándote en las siguientes instrucciones:'
  },
  tour_guide: {
    click_on_every_word: {
      title: 'Traducir palabra',
      text: 'Puedes hacer clic en cualquier palabra para ver traducciones, oraciones de ejemplo y definiciones'
    },
    click_on_i_for_sentence: {
      title: 'Frase completa',
      text: 'Para traducir una frase completa, haz clic en el símbolo i. Aquí también puedes obtener explicaciones sobre gramática.'
    },
    no_save_custom: {
      title: 'No se puede guardar',
      text: 'Los propios textos no se pueden guardar'
    },
    change_playback_rate: {
      title: 'Cambiar Velocidad de Reproducción',
      text: 'Cambia la velocidad de reproducción en Menú/Configuración/Audio y Video.'
    },
    theme: {
      title: 'Colores',
      text: 'Puedes cambiar los colores en el menú a modo oscuro'
    },
    repeat_words: {
      title: 'Repetir vocabulario',
      text: 'Debes repetir {nWords} vocabularios.',
      call_to_action: 'Aprender ahora'
    },
    flipcards: {
      title: 'Tarjetas',
      text: 'Dale la vuelta a la tarjeta y haz clic en el emoji feliz o triste para seguir tu progreso'
    },
    synapsis_score: {
      title: 'Puntuación Synapsis',
      text: 'Ganas puntos por cada palabra, ponderados por su nivel, y puntos adicionales por cada capítulo o unidad completada'
    }
  },
  chat: {
    your_message: 'Tu mensaje',
    waiting_for_teacher: 'Esperando al profesor...',
    in_de: 'en alemán',
    in_en: 'en inglés',
    in_es: 'en español',
    in_fr: 'en francés',
    in_it: 'en italiano',
    in_pt: 'en portugués',
    in_ru: 'en ruso',
    in_zh: 'en chino',
    in_pl: 'en polaco',
    wait: 'Por favor espera...',
    speak_now: 'Habla ahora',
    new_chat: 'Nueva conversación',
    switch_language: 'Cambiar idioma',
    language_teacher: 'Profesor de idiomas',
    summarize_mistakes: 'Resumir errores'
  },
  langs: {
    de: 'Alemán',
    en: 'Inglés',
    es: 'Español',
    fr: 'Francés',
    it: 'Italiano',
    pt: 'Portugués',
    ru: 'Ruso',
    zh: 'Chino',
    pl: 'Polaco'
  },
  countries: {
    de: 'Alemania',
    en: 'Inglaterra',
    es: 'España',
    fr: 'Francia',
    it: 'Italia',
    pt: 'Portugal',
    ru: 'Rusia',
    pl: 'Polonia',
    zh: 'China'
  },
  about: {
    how_does_it_work: 'Como funciona?',
    here_you_can: 'Aquí puedes',
    read_texts: 'leer textos',
    watch_videos: 'ver videos',
    click_on_every_wrord_for: 'Haz clic en cualquier palabra para',
    translations: 'traducciones',
    examples: 'ejemplos',
    definitions: 'definiciones',
    synonyms: 'sinónimos',
    copy_your_own_text: 'Copia y leer tu propio texto',
    chat_with_chatbot: 'Chatea con un chatbot',
    level: 'Tu nivel debería estar entre B1 y C2'
  },
  settings: {
    audio_video: 'Audio y Video',
    level: 'Nivel',
    colors: 'Color',
    dark_mode: 'Modo oscuro',
    lang_level: 'Nivel de idioma',
    show_pinyin: 'Mostrar pinyin',
    show_translation: 'Mostrar traducción'
  },
  error: {
    resource_not_found: 'Lo sentimos, no pudimos encontrar lo que buscas'
  },
  train: {
    check: 'Comprobar',
    flashcards: 'Tarjetas de memoria',
    exercises: 'Ejercicios',
    finished: 'Ejercicios terminados',
    go_to_favorites: 'Ir a favoritos',
    restart_exercise: 'Reiniciar ejercicio',
    go_to_home: 'Ir a inicio',
    text_with_words: 'Texto con palabras',
    text_includes: 'El texto incluye todas las palabras que quieres aprender',
    generate_audio: 'Generar audio',
    stop_audio: 'Detener audio'
  },
  wordmap: {
    click_on_circle: 'Haz clic en el círculo para ver las palabras más utilizadas con {word}',
    click_on_edge: 'Haz clic en la línea entre dos palabras para ver una frase con ambas palabras',
    open_fullscreen: 'Abrir en pantalla completa',
    add_own_word: 'Añadir palabra propia',
    add_sentence_with_all_words: 'Añadir frase con todas las palabras',
    add_to_word: 'Agregar a la palabra'
  },
  conversations: {
    you_are: 'Tu eres',
    you_talk_to: 'Tu hablas con',
    your_tasks: 'Tus tareas'
  },
  write: {
    min_words: 'Palabras mínimas',
    your_email_needs_to_contain: 'Tu correo electrónico debe contener',
    rate: 'Calificar',
    analysis: 'Análisis',
    overall: 'General',
    grammar: 'Gramática',
    content: 'Contenido',
    spelling: 'Ortografía',
    passed: '¡Bien hecho! Has superado este ejercicio.',
    failed: '¡Sigue practicando! Tu puntuación no fue suficiente para pasar.',
    restart: 'Intentar de nuevo'
  },
  cookies: {
    title: 'This website uses cookies',
    description:
      "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services.",
    description_short:
      'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic...',
    deny: 'Deny',
    allow_selection: 'Allow selection',
    clear_local_storage: 'Clear local storage keys',
    clear_local_storage_confirm: 'Are you sure you want to remove selected local storage keys?',
    clear_local_storage_success: 'Selected local storage keys have been removed.',
    tooltip_necessary:
      'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
    tooltip_preferences:
      'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
    tooltip_statistics:
      'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    tooltip_marketing:
      'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.'
  },
  grammar: {
    start_grammar_lessons: 'Iniciar lecciones de gramática'
  },
  transcription: {
    title: 'Transcripción en vivo',
    subtitle: 'Escucha una conversación y velá escrita en pantalla mientras hablas',
    start: 'Iniciar transcripción',
    stop: 'Detener',
    listening: 'Escuchando…',
    transcribing: 'Transcribiendo…',
    mic_settings_title: 'Ajustes del micrófono',
    mic_mode_close: 'Voz cercana',
    mic_mode_distant: 'Distante / reproducción',
    mic_boost_label: 'Ganancia del micrófono',
    mic_settings_hint: 'Se aplica la próxima vez que empieces',
    mic_level_label: 'Nivel de entrada del micrófono',
    mic_level_clipping: 'Demasiado alto',
    mic_test_start: 'Probar micrófono',
    mic_test_stop: 'Detener prueba',
    empty_state: 'Toca "Iniciar transcripción" y empieza a hablar: lo que se diga aparecerá aquí',
    not_supported:
      'La transcripción en vivo no es compatible con este navegador. Asegúrate de que el acceso al micrófono esté disponible.',
    microphone_error:
      'No se pudo acceder al micrófono. Comprueba los permisos del micrófono e inténtalo de nuevo.',
    transcription_error: 'No se pudo transcribir esa parte. Sigue escuchando…',
    copied: 'Transcripción copiada al portapapeles'
  },
  video_object_detection: {
    title: 'Detección de Objetos en Video',
    subtitle:
      'Apunta tu cámara a los objetos que te rodean y descubre cómo se llaman en el idioma que estás aprendiendo',
    start: 'Iniciar Video',
    stop: 'Detener',
    scanning: 'Escaneando…',
    empty_state:
      'Toca "Iniciar Video" y apunta tu cámara a los objetos para verlos etiquetados aquí',
    not_supported:
      'El acceso a la cámara no es compatible con este navegador. Prueba con Chrome o Edge.',
    camera_error:
      'No se pudo acceder a la cámara. Comprueba los permisos de la cámara e inténtalo de nuevo.',
    detected_words: 'Palabras detectadas',
    nearby_objects: 'Otros objetos cercanos: toca para añadir'
  }
};
